<template>
  <div>
    <div class="operation1 flex-start" v-if="type=='list'">
      <span :class="['iconfont', $attrs.has_like ? 'iconexpdianjihou' : 'iconRectangle1']"></span>
      <span class="approve-total" :style="{color:$attrs.has_like?'#f64':'#404040'}">{{$attrs.has_like?'Exp+1':($attrs.num>0?$attrs.num:'Exp')}}</span>
      <transition name="exp1">
        <span class="approve-total animation exp1" v-if="$attrs.has_like">Exp+1</span>
      </transition>
      <transition name="exp2">
        <span class="approve-total animation exp2" v-if="$attrs.has_like">Exp+1</span>
      </transition>
      <transition name="exp3">
        <span class="approve-total animation exp3" v-if="$attrs.has_like">Exp+1</span>
      </transition>
    </div>
    <div v-else class="exp">
      <span class="iconfont"
            :class="$attrs.has_like ? 'iconexpdianjihou' : 'iconRectangle1'"></span>
      <span class="comment-total total-count" :style="{color:$attrs.has_like?'#f64':'#404040'}">{{$attrs.has_like?'Exp+1':($attrs.num>0?$attrs.num:'Exp')}}</span>
      <transition name="exp1">
        <span class="approve-total animation exp1" style="bottom:6px;right:10px" v-if="$attrs.has_like">Exp+1</span>
      </transition>
      <transition name="exp2">
        <span class="approve-total animation exp2" style="bottom:6px;right:10px" v-if="$attrs.has_like">Exp+1</span>
      </transition>
      <transition name="exp3">
        <span class="approve-total animation exp3" style="bottom:6px;right:10px" v-if="$attrs.has_like">Exp+1</span>
      </transition>
    </div>
  </div>
</template>

<script>
  export default {
    name: "animationExp",
    props: {
      type: [String]
    }
  }
</script>

<style lang="scss" scoped>
  @import "../../../assets/scss/global/variable";
  @import "../../../assets/scss/global/mixin";


  .operation1 {
    font-size: $font-size-small;
    position: relative;
    width: 64px;
    margin-right: -10px;
    line-height: 24px;

    .iconfont {
      font-size: 24px;
      margin-right: 3px;
    }

    .iconexpdianjihou {
      color: #f64;
    }

    .iconRectangle1 {
      color: #404040;
    }

    .approve-total {
      font-size: 12px;
    }


  }

  .exp {
    .iconfont {
      font-size: 22px;
      color: $color-title;
      position: absolute;
      top: 5px;
      left: calc((100% - 22px) / 2);
    }

    .iconexpdianjihou {
      color: #f64;
    }

    .iconRectangle1 {
      color: #404040;
    }

    .total-count {
      position: absolute;
      font-size: $font-size-small-s;
      color: $color-title;
      bottom: 6px;
      left: 0;
      right: 0;
      text-align: center;
    }
    .approve-total {
      font-size: 12px;
    }

  }

  .animation {
    position: absolute;
    bottom: 0px;
    right: 4px;
    opacity: 0;
    color: #f64;
    z-index: 999;
    font-size: 12px;
  }
  .exp1-enter-active {
    transform: translateY(-35px);
    opacity: 0;
    transition: all .8s;
  }

  .exp1-enter {
    transform: translateY(0px);
    opacity: 1;
    transition: all 0s;
  }

  .exp2-enter-active {
    transform: translateY(-35px);
    opacity: 0;
    transition: all .8s .3s;
  }

  .exp2-enter {
    transform: translateY(0px);
    opacity: 1;
    transition: all 0s 0.3s;
  }

  .exp3-enter-active {
    transform: translateY(-35px);
    opacity: 0;
    transition: all .8s .6s;
  }

  .exp3-enter {
    transform: translateY(0px);
    opacity: 1;
    transition: all 0s 0.6s;
  }

</style>